import React, { Component } from "react";
import PropTypes from 'prop-types';
import * as HttpUtils from "../../utils/http";
import Api from '../../utils/api';
import { Loader } from 'semantic-ui-react'

class Name extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyPressed = this.handleKeyPressed.bind(this);
    this.fun_SubmitUserName = this.fun_SubmitUserName.bind(this);


    this.state = {
      firstName: "",
      lastName: "",
      isCheckoutButton:false,
    };
  }

  componentDidMount(){
   
    // ReactGA 配合谷歌跟踪
    try {
      let skinQuizType = this.props.skinQuizType;
      if(skinQuizType)
      Api.eventTrackingStageProgress(skinQuizType.replace("SQ_",""));
    } catch (error) {}
}

  handleChange = e => {
    if (e.target.name === "firstname") {
      this.setState({ firstName: e.target.value });
    }

    if (e.target.name === "lastname") {
      this.setState({ lastName: e.target.value });
    }
  };

  handleKeyPressed(e) {
    if (e.key === "Enter" && this.state.firstName && this.state.lastName) {
      e.preventDefault();
      this.handleSubmit();
    }
  }

  handleSubmit() {
    if (this.state.firstName && this.state.lastName) {
        this.fun_SubmitUserName();
    }else{
      alert("Please select an answer. ");
    }
  }

  fun_SubmitUserName(){
    let firstName = this.state.firstName;
    let lastName =  this.state.lastName;
    let user_id = localStorage.getItem("user_id");
    this.setState({isCheckoutButton:true});
    HttpUtils.post("/api/surveys/advanced",{
        userId: user_id,
        firstName: firstName,
        lastName: lastName,
      },false).then(()=>{
        localStorage.setItem("SQ_firstname", firstName);
        localStorage.setItem("SQ_lastname", lastName);

        localStorage.setItem("user_firstname", firstName);
        localStorage.setItem("user_global_firstname", firstName);
        localStorage.setItem("user_lastname", lastName);
        localStorage.setItem("user_global_lastname", lastName);
        this.setState({isCheckoutButton:false});
        
        try {
          if(this.props.fun_updateStage){
            var stage = this.props.stage;
            var stageSum = this.props.stageSum;
            if(stage && stageSum)
            this.props.fun_updateStage(stage,stageSum);
          }
        } catch (error) {
          console.error(error);
        }


        try {
          let step = this.props.step;
          localStorage.setItem("doneQuizStepId",step.id);
        } catch (error) {
          console.error(error);
        }

        var name = firstName +" "+ lastName;
        this.props.step.value = {value: name ,label: name};
        this.props.triggerNextStep({
            value: {value: name ,label: name}
        });
      }).catch(err => {
        this.setState({isCheckoutButton:false});
        alert(err);
      })
  }


  render() {
    return (
        <div>
            <ul className="resistration-input-ul">
                <li>
                    <span>First name</span>
                    <input type="text" name="firstname" placeholder="First Name" value={this.state.firstName} onChange={this.handleChange} onKeyPress={this.handleKeyPressed.bind(this)}/>
                </li>
                <li>
                    <span>Last name</span>
                    <input type="text" name="lastname" placeholder="Last Name" value={this.state.lastName} onChange={this.handleChange} onKeyPress={this.handleKeyPressed.bind(this)}/>
                </li>
                <li>
                    <button className="p-a-n-button submit-but" style={{position:'relative'}} onClick={this.handleSubmit}>
                      Continue
                      <Loader onClick={(e)=>{ e.stopPropagation()}} active={this.state.isCheckoutButton} inverted size='huge' className={"but-load-style"}/>
                    </button>
                </li>
            </ul>
        </div>
    );
  }
}

Name.propTypes = {
  steps: PropTypes.object,
};

Name.defaultProps = {
  steps: undefined,
};

export default Name;



// WEBPACK FOOTER //
// ./src/views/onboardingAA/Name.js